<!-- 商家开通申请表 -->
<template>
  <div class="">
    <headerBar/>
    <div class="ysc_banner">
      <div class="c_banner_txt wow fadeInDown">
        <div class="c_banner_subTit">诸葛 智享，京东智慧供应链开放平台</div>
        <div class="c_banner_tit">商家开通申请表</div>
      </div>
    </div>
    <Layout class="ysc_index_content">
      <Content>
        <Form ref="formApply" :model="formApply" :rules="formApplyRules" :label-width="270">
          <FormItem label="京东账号" prop="userName">
            <label for="" slot="label"> 
              京东账号
              <Tooltip content="物流开放平台登录的京东账号" placement="bottom-start">
                <Icon type="ios-help-circle-outline" style="font-size: 16px;" />
              </Tooltip>
            </label>
            <Input v-model="formApply.userName" readonly style="width: 500px"></Input>
          </FormItem>
          <!--商家名称，必须是pin自动获取，不能填写-->
          <FormItem label="商家名称" prop="sellerName">
            <Input v-model="formApply.sellerName" readonly style="width: 500px"></Input>
          </FormItem>
          <!--商家联系人-->
          <FormItem label="商家联系人" prop="realName">
            <Input v-model="formApply.realName" style="width: 500px"></Input>
          </FormItem>
          <!--手机号-->
          <FormItem label="手机号" prop="telNo">
            <Input v-model="formApply.telNo" style="width: 500px"></Input>
          </FormItem>
          <!--邮箱-->
          <FormItem label="邮箱" prop="email">
            <Input v-model="formApply.email" style="width: 500px"></Input>
          </FormItem>
          <!--所属区域-->
          <FormItem label="京东物流服务区域" prop="areaName">
            <!-- <Input v-model="formApply.areaName" style="width: 500px"></Input> -->
            <Select v-model="formApply.areaName" style="width: 500px">
              <Option v-for="item in areaOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="submitFormApply('formApply')">提交</Button>
          </FormItem>
        </Form>
      </Content>
    </Layout>
    <footerBar/>

    <!-- 提交成功之后弹框提示信息 ?? -->
    <Modal
      v-model="saveApplyModal"
      width="800"
      title="申请使用系统成功">
      <p style="font-size: 14px; font-weigth: 700; margin-bottom: 10px;">· 加入以下QQ群可进行问题反馈沟通</p>
      <Row style="text-align: center; font-weigth: 500; margin-bottom: 10px;">
        <Col span="12">
          <p>一群498429128</p>
          <img src="./../../../assets/images/qq1.png" alt="" width="190" height="205">
        </Col>
        <Col span="12">
          <p>二群414458993</p>
          <img src="./../../../assets/images/qq2.png" alt="" width="190" height="205">
        </Col>
        <Col span="12">
          <p>三群561124340</p>
          <img src="./../../../assets/images/qq3.png" alt="" width="190" height="205">
        </Col>
        <Col span="12">
          <p>四群726336845</p>
          <img src="./../../../assets/images/qq4.png" alt="" width="190" height="205">
        </Col>
      </Row>
      <p style="font-size: 14px; font-weigth: 700;">· 进入以下商家论坛可查看系统学习资料</p>
      <p style="margin-left: 10px;">
        <a href="http://mjbbs.jd.com/forum-155-1.html" target="_blank">http://mjbbs.jd.com/forum-155-1.html</a>
      </p>
      <div slot="footer">
        <Button type="primary" @click="modalOk">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import IndexFetch from '@/request/index'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    headerBar: () => import("../components/headerBar/HeaderBar.vue"),
    footerBar: () => import("../components/footer/Footer.vue"),
  },
  data() {
    //这里存放数据
    return {
      currentUser: null,
      sellerInfo: null,
      areaOptions: [],
      formApply: {
        userName: null,
        sellerName: null,
        realName: null,
        telNo: null,
        email: null,
        areaName: '西北',
      },
      formApplyRules: {
        userName: [
          { required: true, message: '未获取到京东账号,请联系管理员！', trigger: 'blur' }
        ],
        sellerName: [
          { required: true, message: '未获取到商家名称,请联系管理员！', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请正确输入商家联系人！', trigger: 'blur' }
        ],
        telNo: [
          { required: true, message: '请输入正确的手机号码！', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入有效的邮箱！', trigger: 'blur', type: 'email' }
        ],
        areaName: [
          { required: true, message: '', trigger: 'blur' }
        ],
      },
      saveApplyModal: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    getSellerNoUser () {
      this.sellerInfo = null
      this.formApply.sellerName = null

      IndexFetch.getSellerNoUser().then((res) => {
        if (res.success && res.body) {
          this.sellerInfo = res.body
          this.formApply.sellerName = this.sellerInfo.sellerName
        } else {
          this.$Notice.error({
            title: '通知',
            desc: res.message
          })
        }
      }).catch((err) => {
        this.$Notice.error({
          title: '通知',
          desc: '获取商家信息失败，请重试'
        })
      })
    },
    submitFormApply (name) {
      this.$refs[name].validate((valid) => {
        let params = {
          ...this.formApply,
          sellerId: this.sellerInfo.sellerId,
          sellerNo: this.sellerInfo.sellerNo,
        }
        // console.log(params)
        IndexFetch.saveApply(params).then((res) => {
          if (res.success) {
            this.$Notice.success({
              title: '通知',
              desc: '申请使用系统成功'
            })
            // modal
            this.saveApplyModal = true
            // ******
          } else {
            this.$Notice.error({
              title: '通知',
              desc: result.message
            })
          }
        }).catch((err) => {
          this.$Notice.error({
            title: '通知',
            desc: '申请使用系统失败，请重试'
          })
        })
      })
    },
    modalOk () {
      this.saveApplyModal = false
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.areaOptions = [
      { label: '华北', value: '华北' },
      { label: '华南', value: '华南' },
      { label: '华中', value: '华中' },
      { label: '华东', value: '华东' },
      { label: '东北', value: '东北' },
      { label: '西南', value: '西南' },
      { label: '西北', value: '西北' }
    ]
    // 
    this.currentUser = this.$route.meta.currentUser
    this.formApply.userName = this.currentUser.userName
    this.getSellerNoUser()
  },
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../assets/scss/yscIndex";
@import "../../../assets/muss/muss";
body{
  background-color: #ffffff;
}
.ysc_banner{
  background: #000 url('../../../assets/images/tbg4.png') top center no-repeat;
  background-size: cover;
  height: 200px;
  .c_banner_txt{
    padding-top: 70px;
  }
  .c_banner_tit{
    font-size: 32px;
  }
  .c_banner_subTit{
    font-size: 24px;
  }
}
.ysc_index_content{
  border: 0;
  width: 1100px;
  padding: 30px;
  min-height: 400px;
}
</style>
